import { language } from "language/default";
export var widgetFilterTypes;
(function (widgetFilterTypes) {
    widgetFilterTypes["investmentType"] = "investmentType";
    widgetFilterTypes["sources"] = "sources";
    widgetFilterTypes["tags"] = "tags";
    widgetFilterTypes["widgetType"] = "widgetType";
})(widgetFilterTypes || (widgetFilterTypes = {}));
export const widgetFilterTypesMapper = new Map([
    [widgetFilterTypes.investmentType, language.en.dashboard.edit.investmentType],
    [widgetFilterTypes.sources, language.en.dashboard.edit.sources],
    [widgetFilterTypes.tags, language.en.dashboard.edit.tags],
    [widgetFilterTypes.widgetType, language.en.dashboard.edit.widgetType]
]);
